import { createGlobalStyle } from 'styled-components'

import 'normalize.css'

import MessinaSansWeb_Regular_woff2 from '../fonts/MessinaSansWeb-Regular.woff2'

import MessinaSansWeb_SemiBold_woff2 from '../fonts/MessinaSansWeb-SemiBold.woff2'

import Roman_Grotesque_WEB_Light_woff2 from '../fonts/Roman_Grotesque_WEB-Light.woff2'


import { Variables } from './Variables'

const GlobalStyle = createGlobalStyle`

    @font-face {
        font-family: 'MessinaSans';
        src: url(${MessinaSansWeb_Regular_woff2}) format('woff2');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'MessinaSans';
        src: url(${MessinaSansWeb_Regular_woff2}) format('woff2');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'MessinaSansBold';
        src: url(${MessinaSansWeb_SemiBold_woff2}) format('woff2');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'Roman Grotesque';
        src: url(${Roman_Grotesque_WEB_Light_woff2}) format('woff2');
        font-style: normal;
        font-weight: 300;
    }

    html {
        background: ${Variables.color.pazola};
        font-family: ${Variables.font.body};
        color: ${Variables.color.white};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        line-height: 1;        
    }

    body, html {
        height: 100%;
    }

    body {
        overscroll-behavior: none;
    }

    a {
        text-decoration: none;
        color: #000000;
    }

    img {
        max-width: 100%;
    }

    ::selection {
        background: ${Variables.color.primary};
        color: white;
    }
    ::-moz-selection {
        background: ${Variables.color.primary};
        color: white;
    }

`

export const theme = {
    flexboxgrid: {
        // Defaults
        gridSize: 12, // columns
        gutterWidth: 1, // rem
        outerMargin: 0, // rem
        mediaQuery: 'only screen',
        container: {
            sm: 90, // rem
            md: 90, // rem
            lg: 90, // rem
        },
        breakpoints: {
            xs: 0, // em
            sm: 48, // em
            md: 64, // em
            lg: 75, // em
        },
    },
}

export default GlobalStyle
